import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../css';

function ArrowFilled(props) {
  const { height, width, iconColor, backgroundColor } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill={backgroundColor} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.501 10C16.9339 10 17.1622 10.5127 16.8726 10.8345L12.3726 15.8345C12.174 16.0552 11.828 16.0552 11.6293 15.8345L7.12933 10.8345C6.83975 10.5127 7.0681 10 7.50098 10H16.501Z"
        fill={iconColor}
      />
    </svg>
  );
}

ArrowFilled.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backgroundColor: PropTypes.string,
  iconColor: PropTypes.string
};

ArrowFilled.defaultProps = {
  height: 24,
  width: 24,
  backgroundColor: 'transparent',
  iconColor: colors.colorBlack
};

export default ArrowFilled;
